var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.3334H3.33333C3.11232 18.3334 2.90036 18.2456 2.74408 18.0893C2.5878 17.933 2.5 17.721 2.5 17.5V2.50002C2.5 2.27901 2.5878 2.06704 2.74408 1.91076C2.90036 1.75448 3.11232 1.66669 3.33333 1.66669H16.6667C16.8877 1.66669 17.0996 1.75448 17.2559 1.91076C17.4122 2.06704 17.5 2.27901 17.5 2.50002V17.5C17.5 17.721 17.4122 17.933 17.2559 18.0893C17.0996 18.2456 16.8877 18.3334 16.6667 18.3334ZM15.8333 16.6667V3.33335H4.16667V16.6667H15.8333ZM11.6667 10V14.1667H8.33333V11.6667H10V10H11.6667ZM10 3.33335H11.6667V5.00002H10V3.33335ZM8.33333 5.00002H10V6.66669H8.33333V5.00002ZM10 6.66669H11.6667V8.33335H10V6.66669ZM8.33333 8.33335H10V10H8.33333V8.33335Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/IconZip.dffce62a.svg";
export { ForwardRef as ReactComponent };